import React from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';

import type { Course } from '@yandex-int/k-common/typings';
import { H1, Text, Link } from 'platform-components';
// @ts-ignore
import { getIsContentManager } from 'platform-components/src/components/user/selectors';
import { withRouterPath, InjectedProps as WithRouterPathHOC } from 'platform-components/hocs';
import PropTypes from 'prop-types';

// @ts-ignore
import PageContentTitle from 'common.components/page-content-title/page-content-title';
import { getCurrentClass } from 'common.components/user/selectors';
import { getTeamIdFromPath } from 'utils/path';
import { getTrimmedName } from 'utils/get-trimmed-name';

import type { ReduxTeacherStore } from '../../../typings';

import './course-view__header.scss';

type StoreProps = ReturnType<typeof mapStateToProps>;

interface Props extends WithRouterPathHOC, StoreProps {
    course: Course;
}

class CourseViewHeader extends React.Component<Props> {
    static contextTypes = {
        staticUrls: PropTypes.object.isRequired,
    };
    context!: React.ContextType<React.Context<{ staticUrls: Record<string, string> }>>;

    getCMLink = () => {
        const { course, getRouterPath, isContentManager } = this.props;
        const {
            staticUrls: { cmCourseSearch },
        } = this.context;

        if (!course || !isContentManager) {
            return null;
        }

        const searchLink = getRouterPath(cmCourseSearch, { courseId: course.id });

        return (
            <Link mix="course-view__header-nav-link" theme={Link.THEME.PRIMARY} to={searchLink}>
                <Text id="courseView.searchCourseProblems" />
            </Link>
        );
    };

    render() {
        const { currentClass } = this.props;
        const { name, level } = (currentClass || {}) as Partial<NonNullable<typeof currentClass>>;

        const link = this.getCMLink();

        return (
            <PageContentTitle
                link={link}
                mix="course-view__title"
                title={<H1 id="courseView.headerWithClassName" values={{ name: getTrimmedName(name), level }} />}
            />
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore) => {
    const classId = getTeamIdFromPath();

    return {
        currentClass: getCurrentClass(storeState, { classId }),
        isContentManager: getIsContentManager(storeState),
    };
};

export default compose<any>(withRouterPath, connect(mapStateToProps))(CourseViewHeader);
